module.exports = __webpack_public_path__ + "static/media/SWSCRC2-06.18ce2b23.mp3";